module.exports = __webpack_public_path__ + "img/CartonBarCode.c656e76b.png";